import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__tabs-wrapper flex column no-wrap bg-white q-px-md q-pt-md flex-1" }
const _hoisted_2 = { class: "flex column no-wrap gap-lg custom-scrollbar overflow-auto q-pb-20" }
const _hoisted_3 = { class: "flex column no-wrap gap-lg custom-scrollbar overflow-auto q-pb-20" }

import { reactive } from 'vue'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../../../pages/Inventory/Item/ItemLibrary/translate/itemLibrary.translate'
import globalTranslateObject from 'src/translate/global.translate'
import BaseItemDialogPricing from './BaseItemDialogPricing.vue'
import BaseItemDialogItemType from './BaseItemDialogItemType.vue'
import BaseItemDialogUnits from './BaseItemDialogUnits.vue'
import BaseItemDialogPOS from './BaseItemDialogPOS.vue'
import BaseItemDialogIngredients from './BaseItemDialogIngredients.vue'
import BaseItemDialogAllergens from './BaseItemDialogAllergens.vue'
import BaseItemDialogVariations from './BaseItemDialogVariations.vue'
import BaseItemDialogModifiers from './BaseItemDialogModifiers.vue'
import { IItemView } from 'src/common/interfaces'

interface IProps {
  item: IItemView
  currency: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogTabs' },
  __name: 'BaseItemDialogTabs',
  props: {
    item: {},
    currency: {}
  },
  setup(__props: any) {




const { t } = translate(translationObject)
const { t: globalT } = translate(globalTranslateObject)

const state = reactive({
  activeTab: 'info',
  tabs: [
    { label: t('tabs.general_info'), name: 'info' },
    // { label: 'Variations', name: 'variations' },
    { label: globalT('modifiers'), name: 'modifiers' },
  ],
})

return (_ctx: any,_cache: any) => {
  const _component_k_tab = _resolveComponent("k-tab")!
  const _component_k_tab_panel = _resolveComponent("k-tab-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_tab, {
      modelValue: state.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.activeTab) = $event)),
      tabs: state.tabs,
      class: "BaseItemDialog__tabs"
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    _createVNode(_component_k_tab_panel, {
      modelValue: state.activeTab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.activeTab) = $event)),
      "tab-panel-class": "q-px-none q-pb-none q-pt-20"
    }, {
      info: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BaseItemDialogPricing, {
            item: __props.item,
            currency: __props.currency
          }, null, 8 /* PROPS */, ["item", "currency"]),
          _createVNode(BaseItemDialogItemType, { item: __props.item }, null, 8 /* PROPS */, ["item"]),
          _createVNode(BaseItemDialogUnits, { item: __props.item }, null, 8 /* PROPS */, ["item"]),
          _createVNode(BaseItemDialogPOS, { item: __props.item }, null, 8 /* PROPS */, ["item"]),
          _createVNode(BaseItemDialogIngredients, { item: __props.item }, null, 8 /* PROPS */, ["item"]),
          _createVNode(BaseItemDialogAllergens, { item: __props.item }, null, 8 /* PROPS */, ["item"])
        ])
      ]),
      variations: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BaseItemDialogVariations, { currency: __props.currency }, null, 8 /* PROPS */, ["currency"])
        ])
      ]),
      modifiers: _withCtx(() => [
        _createVNode(BaseItemDialogModifiers, {
          item: __props.item,
          currency: __props.currency
        }, null, 8 /* PROPS */, ["item", "currency"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})